import { useState } from 'react'
import Cookies from 'js-cookie'
import { usePropertyFetcher } from './usePropertyFetcher'
import { useVisaValdaStore } from '../store/VisaValdaStore'
import { usePropsDataStore } from '../store/PropsDataStore'
import { regenerateProperty as regeneratePropertyAPI } from '../../../api/services/property'

export const usePropertyRegeneration = () => {
    const { checkPropStatus } = usePropertyFetcher()
    const setVisaValda = useVisaValdaStore((state) => state.setVisaValda)
    const { props, setProps, setOneProp } = usePropsDataStore()
    const [loading, setLoading] = useState(false)

    const removePropertyFromCookie = (ref) => {
        let activePropsCookie = Cookies.get('activeProps')
        if(activePropsCookie){
            let propList = activePropsCookie.split(',').filter(prop => prop != ref)
            Cookies.set('activeProps', propList.map(p => p).join(','))
        }
    }

    const regenerateProperty = async (selectedProperty, onSuccess) => {
        setLoading(true)

        try {
            const response = await regeneratePropertyAPI(selectedProperty.ref, selectedProperty.designation)
            const json = response.data

            if (json.error) {
                setLoading(false)
                return { error: json.error }
            }

            let selectedProp
            const updatedProps = props.map((p) => {
                if (p.ref == selectedProperty.ref) {
                    selectedProp = { ...p, active: false, checked: false, loading: true, locked: true };
                    return selectedProp;
                }
                return p;
            })
            setProps(updatedProps)
            setVisaValda(true)
            removePropertyFromCookie(selectedProp.ref)
            setLoading(false)
            
            checkPropStatus(setOneProp, selectedProp)
            
            if (onSuccess) {
                onSuccess(selectedProp, json)
            }

            return { success: true, prop: selectedProp, date: json.date }
        } catch (error) {
            setLoading(false)
            return { error: error.message || 'Failed to regenerate property' }
        }
    }

    return { regenerateProperty, loading }
}
